export function getDateToday(): string {
    const date = new Date();
    
    return (
      date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, '0') + "-" +
      String(date.getDate()).padStart(2, '0') + " " +
      String(date.getHours()).padStart(2, '0') + ":" +
      String(date.getMinutes()).padStart(2, '0') + ":" +
      String(date.getSeconds()).padStart(2, '0')
    );
  }

export function  getDateTodayAddHour(): string{
    var date = new Date();
    const numOfHours = 12;
    date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);

    var dateStr =
      (date.getFullYear() + "-") +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) + " " +
      ("00" + date.getHours()).slice(-2) + ":" +
      ("00" + date.getMinutes()).slice(-2) + ":" +
      ("00" + date.getSeconds()).slice(-2);
    return dateStr;

  }
  